import React from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';

function MacExternalInfo(props) {

  return (
    <BDialog disableRestoreFocus open={props.open} onClose={props.onClose}>
      <DialogContent>
        <p>
            {TR.cm_ext_window_if_ipad}
        </p>
        <p>
            {TR.cm_ext_window_if_mac}
        </p>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onOpen()}>{TR.cm_open_video_window}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default MacExternalInfo;